import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { ISubmissionMetadata } from '@publishing-engine/domain/models/submission.js';
import { FormFieldFundingGeneric } from '@publishing-engine/domain/types/article.js';
import { FundingGenericEmptyState } from './FundingGenericEmptyState.js';
import { FundingGenericDisplay } from './FundingGenericDisplay.js';

interface Props {
  value?: ISubmissionMetadata['fundingGeneric'];
  previousValue?: ISubmissionMetadata['fundingGeneric'];
  onClose: () => void;
  config: Omit<FormFieldFundingGeneric, 'component'>;
}

export const FundingGenericDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.exists;
  const hasCurrent = !!value?.exists;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          {!hasPrevious ? (
            <FundingGenericEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FundingGenericDisplay
              value={previousValue.value}
              exists={
                config?.params.labels.options[previousValue.exists]?.main || ''
              }
            />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          {!hasCurrent ? (
            <FundingGenericEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FundingGenericDisplay
              value={value.value}
              exists={config?.params.labels.options[value.exists]?.main || ''}
            />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
